import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useApolloClient, useQuery } from '@apollo/client';

import { GET_CUSTOMER, switchCustomer } from '../../shared';

export default function useSwitchCustomer(uuid) {
  const [sentUuid, setSentUuid] = useState(false);

  const history = useHistory();
  const client = useApolloClient();

  const { data: customerData, loading: customerDataLoading } = useQuery(GET_CUSTOMER);
  const currentCustomer = customerData?.customer;

  useEffect(() => {
    const switchCustomerToUuid = switchCustomer(client, history);

    if (!customerDataLoading && !!uuid && !sentUuid) {
      setSentUuid(true);
      if (currentCustomer) {
        switchCustomerToUuid(uuid);
      }
    }
  }, [uuid, sentUuid, customerDataLoading, currentCustomer, client, history]);
}
